import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";




export const getWarehouseDictionaryWithAccessApi = (async ( ) => await http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.BaseInformationApi.Warehouse.dictionaryHasAccess,
    method: 'get',
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject( err);
})
)



export const getDetailWarehouseDictionaryWithAccessApi = (async ( warehouseId) => await http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory
                            .BaseInformationApi.WarehouseDetail.dictionary,
    method: 'get',
    params:{warehouseId}
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject( err);
})
)

export const  getWarehouseDictionary =( async (hasWarehouseDetails=true) =>  await http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.BaseInformationApi.Warehouse.dictionary,
    method: 'get',
    params:{
        showWarehousesWithWarehouseDetails:hasWarehouseDetails
    }

}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject( err);
})
)
